import { clsx } from 'clsx';
import { t } from '../../i18n';
import { CrossIcon } from '../icons';
import styles from './ui.module.css';

/**
 * Ярлык внутри карточки: метка предмета с крестиком и «+ метка» пунктиром.
 *
 * Фильтр по меткам над складом — не он, а `FilterSelect`: там у значения
 * есть состояние «выбрано», а у ярлыка выбирать нечего.
 */
export function Chip({
  children,
  add = false,
  onClick,
  onRemove,
  label,
}: {
  children: string;
  /** Пунктирный контур: «завести ещё одну метку» в том же ряду, что и метки. */
  add?: boolean;
  onClick?: () => void;
  /** Крестик справа: у ярлыка в карточке метку можно снять. */
  onRemove?: () => void;
  /** Что это за метка — читалке с экрана одного слова мало. */
  label?: string;
}) {
  const className = clsx(styles.chip, add && styles.chipAdd);

  if (onRemove) {
    return (
      <span className={className}>
        {children}
        <button
          type="button"
          className={styles.chipRemove}
          aria-label={t('ui.chip.remove', { name: children })}
          onClick={onRemove}
        >
          <CrossIcon size={9} />
        </button>
      </span>
    );
  }

  if (!onClick) return <span className={className}>{children}</span>;

  return (
    <button type="button" className={className} aria-label={label} onClick={onClick}>
      {children}
    </button>
  );
}
